import { useNavigate } from "react-router-dom";
import { ScanFace, Sparkles, ClipboardList, ShieldCheck, Smartphone, HeartPulse, Activity } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import PageHeader from "@/components/PageHeader";

export default function AiDoctor() {
  const navigate = useNavigate();
  return (
    <div className="max-w-3xl" data-testid="ai-doctor-page">
      <PageHeader title="AI Doctor — Face Health Scan" subtitle="Contactless vitals from your camera" icon={ScanFace} color="#0EA5E9" />

      <Card className="rounded-3xl p-6 border-border bg-[#0EA5E9]/5">
        <div className="flex items-start gap-4">
          <div className="h-12 w-12 rounded-2xl bg-[#0EA5E9]/15 flex items-center justify-center shrink-0"><ScanFace className="h-6 w-6 text-[#0EA5E9]" /></div>
          <div>
            <h2 className="text-xl font-semibold">Scan your face for instant vitals</h2>
            <p className="text-muted-foreground mt-1.5">Using rPPG technology, the Trata Health mobile app estimates heart rate, stress and more from a 30-second face scan.</p>
          </div>
        </div>
      </Card>

      <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3">
        {[
          { icon: HeartPulse, t: "Heart Rate", c: "#DC2626" },
          { icon: Activity, t: "Stress Level", c: "#7C3AED" },
          { icon: Sparkles, t: "Wellness Index", c: "#16A34A" },
        ].map((f) => {
          const FIcon = f.icon;
          return (
            <Card key={f.t} className="rounded-2xl p-4 border-border flex items-center gap-3">
              <div className="h-10 w-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: f.c + "1A" }}><FIcon className="h-5 w-5" style={{ color: f.c }} /></div>
              <span className="font-semibold text-sm">{f.t}</span>
            </Card>
          );
        })}
      </div>

      <Card className="rounded-2xl p-4 border-border mt-5 flex items-start gap-3 bg-muted/40">
        <Smartphone className="h-5 w-5 text-muted-foreground mt-0.5 shrink-0" />
        <p className="text-sm text-muted-foreground">The camera-based face scan runs on the Trata Health mobile app. On web, chat with Dr Sanjeevani about your symptoms instead.</p>
      </Card>

      <div className="mt-5 flex flex-col sm:flex-row gap-3">
        <Button onClick={() => navigate("/assistant")} className="flex-1 h-12 rounded-2xl bg-[#0EA5E9]" data-testid="ai-doctor-chat"><Sparkles className="h-4 w-4 mr-1.5" /> Chat with Dr Sanjeevani</Button>
        <Button onClick={() => navigate("/ai-doctor/history")} variant="outline" className="flex-1 h-12 rounded-2xl" data-testid="ai-doctor-history"><ClipboardList className="h-4 w-4 mr-1.5" /> Screening History</Button>
      </div>

      <p className="flex items-center justify-center gap-1.5 text-xs text-muted-foreground mt-4"><ShieldCheck className="h-3.5 w-3.5" /> Estimates only — not a medical device.</p>
    </div>
  );
}
